import React from 'react';
import style from '../../../assets/styles/perfil-descargar.module.css';

const Evento = ({evento}) => {

    const descargarConstancia = async() => {

        const isProduction = process.env.NODE_ENV === "production";

            let BASE_URL = "";

            if( isProduction ) {
                BASE_URL = 'https://app-constancias.herokuapp.com/api/v1'
            } else {
                BASE_URL = 'http://localhost:8080/api/v1'
        }

        fetch(BASE_URL+'/asistentes/pdf/' + evento._id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        })
        .then((response) => response.blob() )
        .then((blob) => {

            // Create blob link to download
            const url = window.URL.createObjectURL(
                // new Blob([blob]),
                blob
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                evento.evento.nombre,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        });

    }

    return (<>
        <div className={ style.evento } >
            <p className='mr-2'>
                {evento.evento.nombre}
            </p>
            <button
                onClick={ () => descargarConstancia() } 
                className="bg-primary"
            >
                Descargar
            </button>
        </div>
    </>)
}

export default Evento
